import React from 'react';

import { Link } from 'react-router-dom';

export function Content() {
  return (
    <React.Fragment>
      <section className='breadcrumb'>
        <h1>User Management</h1>
        <ul>
          <li>
            <Link to='/home'>Home</Link>
          </li>
          <li className='divider la la-arrow-right'></li>
          <li>User Management</li>
        </ul>
      </section>
    </React.Fragment>
  );
}
